import React, { Component } from "react";

class CategoryItem extends Component {
	render() {
		const { isSelected, currentlySelected } = this.props;
		const cat = this.props.category;

		const isActive = currentlySelected.some(item => {
			return item.id === cat.id;
		});

		return (
			<div className={"selection" + (isSelected ? " selected" : "") + (isActive ? " active" : "")} onClick={() => this.props.handleCategoryClick(cat)}>
				<div className="txt">{cat.title}</div>
				<span className="icon-star-full" />
			</div>
		);
	}
}

export default CategoryItem;



// WEBPACK FOOTER //
// ./src/components/admin/products/category-search/CategoryItem.js